import { z } from 'zod';

/** Response for `GET /api/health` — liveness plus upstream configuration. */
export const healthResponseSchema = z.object({
  status: z.literal('ok'),
  timestamp: z.iso.datetime(),
  upstreams: z.object({
    /** RainViewer needs no credentials, so this is always available. */
    rainviewer: z.boolean(),
    /**
     * Mapbox is two credentials doing two jobs, and either can be missing on
     * its own — a deploy can serve the Mapbox basemap with search switched
     * off, or the reverse. Reporting one flag for both hides which is broken.
     */
    mapboxBasemap: z.boolean(),
    mapboxGeocode: z.boolean(),
  }),
});
export type HealthResponse = z.infer<typeof healthResponseSchema>;
